// extracted by mini-css-extract-plugin
export default {"content":"UserDropdown-content--MXdje","header":"UserDropdown-header--raxsJ","item":"UserDropdown-item--le9he"};